module.exports = __webpack_public_path__ + "assets/img/TrendingNow_swimming_pool.a9705b9d-ps.jpg";